// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '22.5px',
  height: '22.501px',
  clickable: false,
}

const propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  clickable: PropTypes.bool,
}

// Component
function IconLogOut({ height, width, clickable, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={{ cursor: clickable ? 'pointer' : 'auto' }}
      {...props}
      viewBox="0 0 22.5 22.501"
    >
      <path
        d="M16.365,17.227v1.758A3.52,3.52,0,0,1,12.849,22.5H4.016A3.52,3.52,0,0,1,.5,18.985V3.516A3.52,3.52,0,0,1,4.016,0h8.833a3.52,3.52,0,0,1,3.516,3.516V5.274a.879.879,0,1,1-1.758,0V3.516a1.76,1.76,0,0,0-1.758-1.758H4.016A1.76,1.76,0,0,0,2.258,3.516V18.985a1.76,1.76,0,0,0,1.758,1.758h8.833a1.76,1.76,0,0,0,1.758-1.758V17.227a.879.879,0,0,1,1.758,0Zm5.992-7.487L20.389,7.772a.879.879,0,0,0-1.243,1.243l1.4,1.4H9.993a.879.879,0,1,0,0,1.758H20.546l-1.4,1.4a.879.879,0,1,0,1.243,1.243l1.968-1.968A2.2,2.2,0,0,0,22.357,9.741Zm0,0"
        transform="translate(-0.5)"
      />
    </svg>
  )
}

IconLogOut.defaultProps = defaultProps
IconLogOut.propTypes = propTypes

export default IconLogOut
